import { render, staticRenderFns } from "./NotificationIconDisplay.vue?vue&type=template&id=36e200cc&scoped=true"
import script from "./NotificationIconDisplay.vue?vue&type=script&lang=js"
export * from "./NotificationIconDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e200cc",
  null
  
)

export default component.exports